var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-8"},[_c(_vm.calculator,{tag:"component"}),_vm._v(" "),(_vm.show)?_c('CalculationSteps'):_vm._e()],1),_vm._v(" "),_c('Navigation',{attrs:{"calculators":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }